import CTA8 from './CTA8'
export default CTA8
